// src/pages/products/CreateProduct/components/AttributesTab.jsx
import React from 'react';
import { useLocalization } from '../../../../contexts/LocalizationContext';
import AttributeSelector from '../../../../components/product/AttributeSelector/AttributeSelector';
import styles from '../styles/AttributesTab.module.css';

const AttributesTab = ({
  formData,
  errors,
  onAttributesChange,
  onAttributeValuesChange
}) => {
  const { t } = useLocalization();

  return (
    <div className={styles.formCard}>
      <div className={styles.cardHeader}>
        <h2>{t('products.attributes')}</h2>
        <p>{formData.productType === 'variable' ? t('products.attributesVariableDesc') : t('products.attributesDesc')}</p>
      </div>
      <div className={styles.cardContent}>
        <div className={styles.formGroup}>
          <label>{t('products.attributes')}</label>
          <AttributeSelector
            selectedAttributeIds={formData.attributeIds}
            selectedAttributeValueIds={formData.attributeValueIds}
            onAttributesChange={onAttributesChange}
            onAttributeValuesChange={onAttributeValuesChange}
            productType={formData.productType}
            error={errors.attributes}
          />
        </div>
      </div>
    </div>
  );
};

export default AttributesTab;